export default __webpack_public_path__ + "static/sw_webapp-7696458837b5fc00adf921f4bd958310.png";